<template>
  <section class="diagnosisNavigator">
    <div class="diagnosisNavigatorHeader">
      <div>
        <strong style="text-transform: uppercase;font-size: 14px;">Áreas diagnosticadas</strong>
        <small>Um diagnóstico independente para cada talhão e cultura.</small>
      </div>
      <button type="button" @click="$emit('add')">+ Adicionar diagnóstico</button>
    </div>

    <div class="diagnosisCards">
      <article
        v-for="(diagnosis, index) in diagnoses"
        :key="diagnosis.id"
        class="diagnosisCard"
        :class="{ active: diagnosis.id === activeId }"
        @click="$emit('select', diagnosis.id)"
      >
        <div class="diagnosisCardTitle">
          <span>{{ index + 1 }}</span>
          <div style="width: 65%;">
            <b style="font-size: 12px;">{{ diagnosis.nomeTalhao || `Diagnóstico ${index + 1}` }}</b>
            <small>{{ diagnosis.cultureName || "Cultura não informada" }}</small>
            <small>{{ targetCount(diagnosis) }} alvos</small>
          </div>
          <div class="diagnosisCardFooter">
            <button
              type="button"
              title="Duplicar diagnóstico"
              @click.stop="$emit('duplicate', diagnosis.id)"
            >
              Duplicar
            </button>
            <button
              v-if="diagnoses.length > 1"
              type="button"
              class="remove"
              title="Remover diagnóstico"
              @click.stop="$emit('remove', diagnosis.id)"
            >
              Remover
            </button>
          </div>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import { diagnosisTargetCount } from "./inspectionDiagnosis";

export default {
  props: {
    diagnoses: { type: Array, required: true },
    activeId: { type: String, required: true },
  },
  methods: {
    targetCount: diagnosisTargetCount,
  },
};
</script>

<style scoped>
.diagnosisNavigator {
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #d7e8e1;
  border-radius: 10px;
  background: #f7faf9;
}
.diagnosisNavigatorHeader,
.diagnosisCardTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.diagnosisCardFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 3px;
}
.diagnosisNavigatorHeader > div,
.diagnosisCardTitle > div {
  display: flex;
  flex-direction: column;
}
.diagnosisNavigatorHeader small,
.diagnosisCardTitle small,
.diagnosisCardFooter small {
  color: #667c75;
  font-size: 10px;
}
.diagnosisNavigator button {
  padding: 5px 10px;
  border: 1px solid #006256;
  border-radius: 3px;
  color: #006256;
  background: #fff;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
}
.diagnosisCards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 10px;
  margin-top: 10px;
}
.diagnosisCard {
  padding: 10px;
  border: 1px solid #d6e2de;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
}
.diagnosisCard.active {
  border-color: #006256;
  box-shadow: 0 0 0 2px rgba(0, 98, 86, 0.1);
}
.diagnosisCardTitle {
  justify-content: space-between;
}
.diagnosisCardTitle > span {
  display: grid;
  place-items: center;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  color: #fff;
  background: #006256;
  font-size: 11px;
}
.diagnosisCardFooter {
  margin-top: 6px;
}
.diagnosisCardFooter > div {
  display: flex;
  gap: 5px;
}
.diagnosisCardFooter button {
  padding: 3px 6px;
}
.diagnosisCardFooter .remove {
  border-color: #d49b96;
  color: #9b2c24;
}
@media (max-width: 600px) {
  .diagnosisNavigatorHeader {
    align-items: stretch;
    flex-direction: column;
  }
  .diagnosisCards {
    grid-template-columns: 1fr;
  }
}
</style>
